var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
import { AmplitudeLogLevel } from "@sennder/senn-node-analytics-frontend/lib/types.js";
const LOG_PREFIX = `[amplitude-logger]`;
class AppAmplitudeLogger {
  constructor(logger) {
    __publicField(this, "_level", AmplitudeLogLevel.Warn);
    __publicField(this, "_logger");
    this._logger = logger;
    this.log = this.log.bind(this);
    this.warn = this.warn.bind(this);
    this.error = this.error.bind(this);
    this.debug = this.debug.bind(this);
    this.enable = this.enable.bind(this);
    this.disable = this.disable.bind(this);
  }
  disable() {
    this._level = AmplitudeLogLevel.None;
  }
  enable(logLevel) {
    this._level = logLevel;
  }
  log(...args) {
    if (this._level < AmplitudeLogLevel.Verbose) {
      return;
    }
    console.log(...args);
  }
  warn(warn, ...rest) {
    if (this._level < AmplitudeLogLevel.Warn) {
      return;
    }
    const warnString = String(warn) || "Unknown warning";
    this._logger.warn(`${LOG_PREFIX} warning: ${warnString}`, { warn, ...rest });
  }
  error(error, ...rest) {
    if (this._level < AmplitudeLogLevel.Error) {
      return;
    }
    const errorMessage = String(error) || "Unknown error";
    const errorText = errorMessage.toLowerCase();
    const isNetworkError = errorText.includes("failed to fetch") || errorText.includes("networkerror") || errorText.includes("load failed") || errorText.includes("fetch error");
    if (isNetworkError) {
      this._logger.warn(`${LOG_PREFIX} warning: ${errorMessage}`, {
        warn: error,
        ...rest
      });
      return;
    }
    this._logger.error(`${LOG_PREFIX} error: ${errorMessage}`, {
      error,
      ...rest
    });
  }
  debug(...args) {
    if (this._level < AmplitudeLogLevel.Debug) {
      return;
    }
    console.debug(...args);
  }
}
export {
  AppAmplitudeLogger
};
